import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBatteryLow: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="battery-low, power"><path fillRule="evenodd" clipRule="evenodd" d="M1.75 5C1.33579 5 1 5.33579 1 5.75V18.25C1 18.6642 1.33579 19 1.75 19H19.25C19.6642 19 20 18.6642 20 18.25V16H22.25C22.6642 16 23 15.6642 23 15.25V8.75C23 8.33579 22.6642 8 22.25 8H20V5.75C20 5.33579 19.6642 5 19.25 5H1.75ZM20 9.5V14.5H21.5V9.5H20ZM6 9C6.41421 9 6.75 9.33579 6.75 9.75V14.25C6.75 14.6642 6.41421 15 6 15C5.58579 15 5.25 14.6642 5.25 14.25V9.75C5.25 9.33579 5.58579 9 6 9Z" fill="currentColor"/></CentralIconBase>;
};

export default IconBatteryLow;
